import { observer } from "mobx-react-lite";
import { useParams } from "@tanstack/react-router";

import { LoadingIndicator } from "@synthesis/shared-ui";

import { FileSystem, type FileSystemTab } from "../../../modules/filesystem";
import { useQueryProject } from "../../../entity/project";
import { AccessDenied, PROJECT_ACCESS_DENIED_MESSAGE } from "../../components/access-denied";
import { useProjectAccessError, useUserRolesGGE } from "../../hooks";

type FilesystemPageProps = {
  fixedTab?: FileSystemTab;
  hideTabs?: boolean;
};

export const FilesystemPage = observer(({ fixedTab, hideTabs }: FilesystemPageProps) => {
  const { projectId } = useParams({ strict: false });
  const { project, isLoading, isError, error } = useQueryProject(projectId);
  const roles = useUserRolesGGE();
  const isAccessError = useProjectAccessError(isError, error);
  const isIntegration = project?.meta?.find((meta) => meta.key === "sourceSystem");

  if (!projectId) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex h-[calc(100vh-70px)] items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  if (isAccessError) {
    return <AccessDenied message={PROJECT_ACCESS_DENIED_MESSAGE} />;
  }

  return (
    <FileSystem
      projectId={projectId}
      archivedProject={!!project?.isArchived}
      rolesGGE={roles}
      isIntegration={!!isIntegration}
      fixedTab={fixedTab}
      hideTabs={hideTabs}
    />
  );
});
